import { isAdmin } from '../services/adminAuth.js';
export const AdminIndicator = {
  data() {
    return {
      isAdmin: false
    };
  },
  methods: {
    async checkAdminStatus() {
      const user = firebase.auth().currentUser;
      if (!user) return;

      try {
        this.isAdmin = await isAdmin();
      } catch (err) {
        console.error("Error checking admin status:", err);
        this.isAdmin = false;
      }
    }
  },
  mounted() {
    // Check initial status
    this.checkAdminStatus();

    // Listen for auth state changes
    this.unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.checkAdminStatus();
      } else {
        this.isAdmin = false;
      }
    });
  },
  unmounted() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  template: "#admin-indicator"
};
